import {
  PRODUCT_RESULTS_UPLOAD_CONFIG_LOADED,
  PRODUCT_RESULTS_UPLOAD_CONFIG_CLEAR,
  PRODUCT_RESULTS_INFRINGEMENTS_LOADED,
  PRODUCT_RESULTS_INFRINGEMENTS_CLEAR,
  PRODUCT_RESULTS_INFRINGEMENTS_META_LOADED,
  PRODUCT_RESULTS_INFRINGEMENTS_META_CLEAR,
  PRODUCT_RESULTS_REMOVALS_LOADED,
  PRODUCT_RESULTS_REMOVALS_CLEAR,
  PRODUCT_RESULT_DETAIL_LOADED,
  PRODUCT_RESULT_DETAIL_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  resultsUploadConfig: null,
  infringements: null,
  infringementsMeta: null,
  confirmedRemovals: null,
  resultDetail: null,
};

const productResults = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_RESULTS_UPLOAD_CONFIG_LOADED:
      return { ...state, resultsUploadConfig: action.payload.uploadConfig };

    case PRODUCT_RESULTS_UPLOAD_CONFIG_CLEAR:
      return initialState;

    case PRODUCT_RESULTS_INFRINGEMENTS_LOADED:
      return { ...state, infringements: action.payload.infringements };

    case PRODUCT_RESULTS_INFRINGEMENTS_CLEAR:
      return { ...state, infringements: null };

    case PRODUCT_RESULTS_INFRINGEMENTS_META_LOADED:
      return { ...state, infringementsMeta: action.payload.meta };

    case PRODUCT_RESULTS_INFRINGEMENTS_META_CLEAR:
      return { ...state, infringementsMeta: null };

    case PRODUCT_RESULTS_REMOVALS_LOADED:
      return { ...state, confirmedRemovals: action.payload.removals };

    case PRODUCT_RESULTS_REMOVALS_CLEAR:
      return { ...state, confirmedRemovals: null };

    case PRODUCT_RESULT_DETAIL_LOADED:
      return { ...state, resultDetail: action.payload.detail };

    case PRODUCT_RESULT_DETAIL_CLEAR:
      return { ...state, resultDetail: null };

    default:
      return state;
  }
};

export default productResults;
